<template>
  <div class="strains responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader :pageHeader="listPageHeader" :links="[
        { name: 'home', label: 'Home' },
        { name: 'strains', label: 'Strains' },
      ]" :entity="entity" :hideAddButton="true">
        <!-- <Button label="Sync Strains" iconGroup="fas" iconName="file-export" :colorType="2" @click="syncStrains()" :isLoading="strainsLoadingStatus.pullStrains" /> -->
      </PageHeader>

      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort" :pagination="pagination"
        @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

  <script>
  import PageHeader from "@/components/PageHeader.vue";
  import moment from "moment";
  import Entities from "@/resources/Entities";
  import SearchTable from "@/components/SearchTable.vue";
  import { listPageHeader } from "./inputs";
  import { mapActions, mapGetters } from "vuex";
  import Button from "@/components/Base/Button/Button.vue";

  export default {
    name: "strains",
    data() {
      return {
        moment: moment,
        Entities,
        entity: Entities.STRAIN,
        listPageHeader,
      };
    },
    components: {
      PageHeader,
      SearchTable,
      // Button,
    },
    mounted: function () {
      this.setPageTitle("Strains");
    },
    computed: {
      ...mapGetters({
        sort: "strainModule/sort",
        pagination: "strainModule/pagination",
        initialFilter: "strainModule/initialFilter",
        strainsLoadingStatus: "stateModule/loadingStatus"
      }),
    },
    methods: {
      ...mapActions({
        updateSort: "strainModule/updateSort",
        updatePagination: "strainModule/updatePagination",
        updateInitialFilter: "strainModule/updateInitialFilter",
        pullStrains: "stateModule/pullStrains",
        setMessage: "setMessage",
      }),

      syncStrains() {

        const positiveCallback = (response) => {
            const {successCount, failedStrains} = response

            if(failedStrains?.length > 0) {
              const failedStrainsNames = failedStrains?.map(m => m.message).join("\n");
              this.setMessage({
                title: "Partial State Sync",
                text: "Synced " + successCount + " strains.\n\nFailed to sync " + failedStrains.length + " strains:\n" + failedStrainsNames,
                type: "state-error"
              });
              return;
            }

            const text = successCount > 0 ? "Synced " + successCount + " strain(s)!" : "Up to date!";
            this.setMessage({
              isOpen: true,
              text: text,
              type: "success"
            });
        };

        this.pullStrains({positiveCallback});
      }
    }
  };
  </script>